export * from './NewsDetails';
export * from './NewsDetails.types';
